import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useHistory } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { getLastResentTime, resendEmail, resetPassword } from "../redux/authCrud";
import { swalError, swalSuccess, swalWarning } from "../../../helpers/swal";
import * as jobAction from "../../../_redux/jobActions";
import { useDispatch, useSelector } from "react-redux";
import AutoDismissAlert from "../../../components/toolkit/AutoDismissAlert";
import moment from "moment";
const COMPANY_ID = process.env.REACT_APP_COMPANY_ID;

function ResentEmail(props) {
  const { intl } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const { systemInfo } = useSelector((state) => state.job);
  const [timer, setTimer] = useState(0);
  const [intervalId, setIntervalId] = useState(null);
  const [initialValues, setInitialValues] = useState({
    email: "",
  });

  useEffect(() => {
    dispatch(jobAction.fetchALLSystemInfo());

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [dispatch, intervalId]);

  const ResetPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email("Wrong email format")
      .min(3, "Minimum 3 value")
      .max(50, "Maximum 50 value")
      .required(),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  useEffect(() => {
    const savedMail = localStorage.getItem("resend-email");
    if (savedMail) {
      setInitialValues({ email: savedMail });
      getLastResentTime({email: savedMail}).then((data) => {
        if (data?.data?.success && data?.data?.data?.time) {
          const time = moment().diff(data?.data?.data?.time, "seconds");
          if (time < 60 && time > 0) {
            setTimer(60-time);
            const id = setInterval(() => {
              setTimer((prev) => {
                if (prev <= 1) {
                  clearInterval(id);
                  return 0;
                }
                return prev - 1;
              });
            }, 1000);
            setIntervalId(id);
          }
        }
      });
    }
  }, []);

  const formik = useFormik({
    initialValues,
    validationSchema: ResetPasswordSchema,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setShow(false);
      setSubmitting(true);
      enableLoading();
      resendEmail(values.email)
        .then((data) => {
          if (data?.data?.success) {
            //setTimeout(() => {
            disableLoading();
            setSubmitting(false);
            swalSuccess(data?.data?.message);
            localStorage.setItem("resend-email", values.email);
            setTimer(60);
            const id = setInterval(() => {
              setTimer((prev) => {
                if (prev <= 1) {
                  clearInterval(id);
                  return 0;
                }
                return prev - 1;
              });
            }, 1000);
            setIntervalId(id);
          } else {
            // swalError('Invalid Email', '');
            swalWarning(data.message || "Something went wrong");
            setError(data.message || "Invalid Email");
            setShow(true);
            disableLoading();
          }
        })
        .catch((error) => {
          console.log({ error });
          setSubmitting(false);
          // setStatus(error?.message);
          // swalError(error?.message);
          setError(error?.message);
          setShow(true);
          disableLoading();
        });
    },
  });

  const DOC_CONTAINER = process.env.REACT_APP_DOC_CONTAINER;
  const DOC_TOKEN = process.env.REACT_APP_DOC_TOKEN;

  return (
    <>
      <div className="login_page_wrapper">
        <div>
          <div className="login_container">
            <div className="logo_box">
              <Link to="/">
                <img
                  className="img-fluid"
                  src={
                    systemInfo
                      ? DOC_CONTAINER + systemInfo?.report_logo + DOC_TOKEN
                      : COMPANY_ID == 1
                      ? "images/login_logo.png"
                      : COMPANY_ID == 3
                      ? "images/bied.png"
                      : COMPANY_ID == 2
                      ? "images/bigd.png"
                      : "images/jpgsph.png"
                  }
                  alt="logo"
                />
              </Link>
            </div>

            <div className="login_form_div">
              <div className="top-header">
                <h3>email verification</h3>
              </div>

              <form onSubmit={formik.handleSubmit}>
                <div className="input_group">
                  <label htmlFor="email" className="form-label">
                    <span className="me-1">*</span>
                    Email
                  </label>
                  <input
                    type="text"
                    placeholder="Enter email address"
                    name="email"
                    {...formik.getFieldProps("email")}
                    autoComplete="off"
                  />
                  <i className="fas fa-envelope"></i>
                </div>
                {formik.touched.email && formik.errors.email ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block text-danger">
                      {formik.errors.email}
                    </div>
                  </div>
                ) : null}

                <div className="submit_btn">
                  <button type="submit" disabled={loading || timer > 0}>
                    {timer > 0
                      ? `Resend in ${timer}s`
                      : "Send Verification Email"}
                  </button>
                </div>

                <div className="link_btn_footer">
                  <Link to="/auth/login" className="text-light">
                    {" "}
                    Back to Login
                  </Link>
                  <Link to="/auth/signup">Create Account</Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ResentEmail;
